import { Settinglable } from "../models/setting"
import { API_PREFIX } from "./constant";
import { Request } from "./request";


export function getSubmitBatch(body: any): Request {
  return {
    url: `${API_PREFIX}/blade-user/datapermissionconfig/submitBatch`,
    method: 'POST',
    body,
  }
}


export function geDataPermissonList(): Request {
  return {
    url: `${API_PREFIX}/blade-user/datapermissionconfig/list`,
    method: 'GET',
  }
}


export interface checkPermissionParams {
  itemCode: any,
  treatmentId?: any
}

export function checkPermission(params: checkPermissionParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/datapermissionconfig/checkPermission`,
    method: 'GET',
    params,
  }
}
